let bodyLockCount = 0;
let lockedScrollY = 0;
let savedBodyStyle: Partial<Record<"overflow" | "position" | "top" | "left" | "right" | "width" | "paddingRight", string>> = {};

/**
 * Modal ve sheet'ler için iç içe kullanımı güvenli, iOS uyumlu scroll kilidi.
 * Son katman kapanınca sayfanın önceki konumu ve inline stilleri geri yüklenir.
 */
export function lockBodyScroll() {
  bodyLockCount += 1;
  if (bodyLockCount === 1) {
    const body = document.body;
    lockedScrollY = window.scrollY;
    savedBodyStyle = {
      overflow: body.style.overflow,
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
      paddingRight: body.style.paddingRight,
    };
    const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    body.style.overflow = "hidden";
    body.style.position = "fixed";
    body.style.top = `-${lockedScrollY}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";
    if (scrollbarWidth) body.style.paddingRight = `${scrollbarWidth}px`;
  }

  let released = false;
  return () => {
    if (released) return;
    released = true;
    bodyLockCount = Math.max(0, bodyLockCount - 1);
    if (bodyLockCount) return;
    const body = document.body;
    body.style.overflow = savedBodyStyle.overflow ?? "";
    body.style.position = savedBodyStyle.position ?? "";
    body.style.top = savedBodyStyle.top ?? "";
    body.style.left = savedBodyStyle.left ?? "";
    body.style.right = savedBodyStyle.right ?? "";
    body.style.width = savedBodyStyle.width ?? "";
    body.style.paddingRight = savedBodyStyle.paddingRight ?? "";
    window.scrollTo({ top: lockedScrollY, left: 0, behavior: "auto" });
  };
}
